import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {TimelineListItem} from "../../_types/memorybox";
import {FormControl} from "@angular/forms";
import {AuthService} from "../../_services/auth.service";
import {SnackbarService} from "../../_services/snackbar.service";
import {AdminService} from "../../_services/admin.service";
import {debounceTime, filter, of, switchMap, tap} from "rxjs";
import {catchError} from "rxjs/operators";
import {User} from "../../_types/user";

@Component({
    selector: 'app-timeline-multi-select',
    standalone: false,
    templateUrl: './timeline-multi-select.component.html',
    styleUrl: './timeline-multi-select.component.scss',
})
export class TimelineMultiSelectComponent {
    @ViewChild('timelineInput') userInput: any;
    @Input() title: string = 'Select Memory Box';
    @Input() placeholder: string = 'Select Memory Box';
    @Input() disabled: boolean = false;
    @Input() value: TimelineListItem | undefined;
    @Input() filter: Record<string, any> | undefined = undefined;
    @Output() timelineSelect: EventEmitter<TimelineListItem[]> = new EventEmitter();
    currentUser!: User;
    isRaa: boolean = false;
    timelineSearchControl: FormControl = new FormControl();
    loading: boolean = false;
    filteredTimelines: TimelineListItem[] = [];
    selectedTimelines: TimelineListItem[] = [];

    constructor(private authService: AuthService,
                private snackbarService: SnackbarService,
                private adminService: AdminService,
                private cdr: ChangeDetectorRef) {
        this.authService.getUser().subscribe({
            next: r => {
                this.currentUser = r;
            }
        })
        this.authService.getDynamicSettings().then((r): void => {
            this.isRaa = r.is_raa;
        });
        this.timelineSearchControl.valueChanges.pipe(
            debounceTime(300),
            filter(value => value?.length > 1),
            tap((): boolean => this.loading = true),
            switchMap(value => {
                let filters: any = {
                    order_by: 'full_name',
                    direction: 'asc',
                    deactivated: false
                }
                if (this.currentUser.role.role_type !== 'admin') {
                    filters.access = 'write'
                }
                filters = Object.assign(filters, this.filter);

                return this.adminService.getTimelines(0, 100, value, filters).pipe(
                    // Handle API errors gracefully without breaking the stream
                    catchError(e => {
                        this.loading = false;
                        this.snackbarService.openSnackBar(e, 'error');
                        return of({results: [] as TimelineListItem[]});
                    })
                );
            })
        ).subscribe(r => {
            this.loading = false;
            this.filteredTimelines = r.results;
            this.cdr.detectChanges();
        });
    }

    ngOnChanges(): void {
        if (this.value) {
            this.timelineSearchControl.setValue(this.value, {emitEvent: false});
        } else {
            this.timelineSearchControl.setValue(null, {emitEvent: false});
        }

        if (this.disabled) {
            this.timelineSearchControl.disable({emitEvent: false});
        } else {
            this.timelineSearchControl.enable({emitEvent: false});
        }
    }

    displayFn = (value: TimelineListItem | number | null): string => {
        if (!value) {
            return '';
        }

        if (typeof value === 'number') {
            const user = this.filteredTimelines.find(x => x.id === value);
            return user
                ? this.authService.getDisplayName(user, !this.isRaa ? 'username' : undefined)
                : '';
        }

        return this.authService.getDisplayName(value, !this.isRaa ? 'username' : undefined);
    };

    nameDisplay(timeline: TimelineListItem): string {
        return this.authService.getDisplayName(timeline, this.isRaa ? 'reference_number' : undefined)
    }

    selectUser(event: TimelineListItem): void {
        this.selectedTimelines.push(event);
        this.timelineSelect.emit(this.selectedTimelines)
        if (this.userInput && this.userInput.nativeElement) {
            this.userInput.nativeElement.value = '';
        }
    }

    removeUser(user: TimelineListItem): void {
        const i: number = this.selectedTimelines.findIndex((x: TimelineListItem): boolean => x === user);
        if (i != null && i >= 0) {
            this.selectedTimelines.splice(i, 1);
        }
        this.timelineSelect.emit(this.selectedTimelines)
    }

    checkIfInArray(item: TimelineListItem, otherArray: TimelineListItem[]): boolean {
        let i
        if (otherArray) {
            i = otherArray.findIndex((x: any): boolean => x === item);
        }
        return (i != null && i >= 0);
    }
}
